import React from 'react';
import { FadeIn } from './FadeIn';
export function CredibilitySection() {
  return <section className="py-24 px-6 bg-navy-dark border-t border-white/5" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <FadeIn data-id="element-14">
          <h2 className="text-3xl md:text-5xl font-serif mb-8" data-id="element-15">
            No es consultoría <span className="text-gold" data-id="element-16">tradicional</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-17">
          <p className="text-lg md:text-xl text-gray-light font-sans mb-10" data-id="element-18">
            Soy ingeniero y MBA con más de 20 años operando negocios reales en
            dos países. Veo los negocios como sistemas — no como listas de
            problemas. Por eso no llego con recomendaciones sueltas. Llego a
            entender cómo está construido el tuyo y qué combinación de
            estructura y tecnología tiene sentido para tu caso.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-19">
          <div className="border-l-4 border-gold pl-6 py-2" data-id="element-20">
            <p className="text-xl md:text-2xl font-serif text-gold italic" data-id="element-21">
              "No soy coach. Soy un operador que acompaña a otros operadores a
              construir estructura, claridad y dirección."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}